import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import classNames from 'classnames';
import styles from './DonutBreakdown.module.scss';

const EMPTY_SEGMENT = [{ key: 'empty', value: 1, color: 'var(--gray-100)' }];

export const DonutBreakdownComponent = ({
  title,
  centerValue,
  centerLabel,
  segments,
  className,
}) => {
  const hasData = Array.isArray(segments) && segments.length > 0;
  const chartSegments = hasData ? segments : EMPTY_SEGMENT;

  return (
    <div className={classNames(styles.donutBreakdown, className)}>
      {title && (
        <Text
          variant={textVariantsEnum.Text_md}
          fontWeight={fontWeightEnum.Semibold}
        >
          {title}
        </Text>
      )}

      <div className={styles.body}>
        <div className={styles.chartArea}>
          <ResponsiveContainer width={140} height={140}>
            <PieChart>
              <Pie
                data={chartSegments}
                cx="50%"
                cy="50%"
                innerRadius={46}
                outerRadius={68}
                dataKey="value"
                startAngle={90}
                endAngle={-270}
                strokeWidth={0}
              >
                {chartSegments.map((seg) => (
                  <Cell key={seg.key} fill={seg.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div className={styles.center}>
            <Text
              variant={textVariantsEnum.Display_xs}
              fontWeight={fontWeightEnum.Bold}
            >
              {centerValue}
            </Text>
            {centerLabel && (
              <Text variant={textVariantsEnum.Text_xs} color="gray-500">
                {centerLabel}
              </Text>
            )}
          </div>
        </div>

        {hasData && (
          <div className={styles.legend}>
            {segments.map((seg) => (
              <div key={seg.key} className={styles.legendItem}>
                <div className={styles.legendLeft}>
                  <span
                    className={styles.dot}
                    style={{ background: seg.color }}
                  />
                  <Text
                    variant={textVariantsEnum.Text_sm}
                    color="gray-600"
                    fontWeight={fontWeightEnum.Normal}
                  >
                    {seg.label}
                  </Text>
                </div>
                <Text
                  variant={textVariantsEnum.Text_sm}
                  color="gray-600"
                  fontWeight={fontWeightEnum.Normal}
                >
                  {seg.value}
                  {seg.percentage != null ? ` (${seg.percentage}%)` : ''}
                </Text>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

DonutBreakdownComponent.displayName = 'DonutBreakdown';
